import React, { useRef, useEffect, useContext, useLayoutEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { TAB_KEYCODE, ARROW_DOWN_KEY } from '../../Utils/constant';
import { DropdownContext } from '../context';
import styles from '@dtsl/css-dropdown/dist/index.module.css';
function Dropdown(props) {
  const dropdownRef = useRef(null);
  const {
    isOpen,
    searchValue,
    setSearchValue,
    setIsOpen,
    isOverlayOpen,
    setIsOverlayOpen,
    isMobile,
    searchRef,
    dropdownControlRef,
    dropdownBodyRef,
    setDropdownWidth
  } = useContext(DropdownContext);
  const {
    label,
    isError,
    children,
    disabled,
    className,
    inputStyles,
    isSearchable,
    labelRequired,
    isDropdownButton,
    specificationText,
    inlineDropdownStyles,
    isAbsoluteDropdown
  } = props;
  const dropdownClass = classNames({
    [styles['sib-dropdown']]: true,
    [styles['dropdown-button']]: isDropdownButton,
    [styles['is-open']]: isMobile ? isOverlayOpen : isOpen,
    [styles['sib-dropdown-error']]: isError,
    [styles['sib-dropdown-absolute']]: isAbsoluteDropdown,
    [className]: !!className
  });
  const labelClass = classNames({
    [styles['sib-dropdown-label']]: true,
    // 'sib-dropdown-disabled': disabled,
    [className]: !!className
  });
  const specificationTextClass = classNames({
    [styles['sib-dropdown-help']]: true,
    // 'sib-dropdown-disabled': disabled,
    [className]: !!className
  });
  const hideDropdownMenu = () => {
    if (isMobile && isOverlayOpen) {
      setIsOverlayOpen(false);
      setSearchValue('');
    } else if (isOpen) {
      setIsOpen(false);
      setSearchValue('');
    }
    dropdownControlRef.current?.classList.remove(styles['sib-dropdown-control-focused']);
  };
  const handleDocumentClick = event => {
    if (dropdownBodyRef.current) {
      if (!(!dropdownBodyRef.current?.contains(event.target) && !dropdownControlRef?.current?.contains(event.target)) && !disabled && isSearchable) {
        searchRef.current?.focus();
        dropdownControlRef.current?.classList.add(styles['sib-dropdown-control-focused']);
      } else {
        if (isMobile && isOverlayOpen && !dropdownRef.current?.contains(event.target) && !dropdownBodyRef.current?.contains(event.target)) {
          hideDropdownMenu();
        }
      }
    } else {
      dropdownControlRef.current?.classList.remove(styles['sib-dropdown-control-focused']);
    }
  };
  const handleDocumentTabKey = event => {
    if (event.keyCode === TAB_KEYCODE) {
      if (dropdownBodyRef && dropdownBodyRef.current) {
        let cList = []; //collapsible list
        let mList = []; //multi-select list
        //List options from different type of dropdown menu list
        const isMultiSelect = dropdownBodyRef?.current?.children[0]?.classList?.contains(styles['sib-dropdown-multi-option']);
        const isCollapsibleList = dropdownBodyRef?.current?.children[1]?.classList?.contains('sib-collapsible');
        const isSectionList = dropdownBodyRef?.current?.children[0]?.classList?.contains(styles['sib-dropdown-option-section-header']);
        if (isMultiSelect) {
          if (isCollapsibleList) {
            Array.from(dropdownBodyRef.current.children).forEach((group, i) => {
              if (i == 0) {
                mList.push(group); // select-all option available
              } else {
                mList.push(group.children[0]);
                Array.from(group.children[1]?.children).forEach(groupChild => {
                  if (!groupChild.classList?.contains(styles['locked'])) {
                    mList.push(groupChild); //group options available
                  }
                });
              }
            });
          } else if (isSectionList) {
            Array.from(dropdownBodyRef.current.children).forEach((group, i) => {
              if (i == 0) {
                mList.push(group); //select-all
              } else {
                if (group.children.length == 1) {
                  Array.from(group.children[0]?.children).forEach(groupChild => {
                    if (!groupChild.classList?.contains(styles['locked'])) {
                      mList.push(groupChild); //Group Options
                    }
                  });
                } else {
                  Array.from(group.children[1]?.children).forEach(groupChild => {
                    if (!groupChild.classList?.contains(styles['locked'])) {
                      mList.push(groupChild); //Group Options
                    }
                  });
                }
              }
            });
          } else {
            Array.from(dropdownBodyRef.current.children).forEach(childrenItem => {
              if (!childrenItem.classList?.contains(styles['locked'])) {
                mList.push(childrenItem); //Single Options
              }
            });
          }
          if (!event.shiftKey && event.target.id === mList[mList.length - 1].querySelector(`.${styles['sib-checkbox-input']}`).id) {
            hideDropdownMenu();
          }
        } else {
          if (isCollapsibleList) {
            Array.from(dropdownBodyRef.current.children).forEach(group => {
              cList.push(group.children[0]); //Group Options
            });
            if (!event.shiftKey && event.target === cList[cList.length - 1]) {
              hideDropdownMenu();
            }
          }
          if ((!dropdownRef.current?.contains(event.target) || event.target.classList?.contains(styles['sib-dropdown-menu'])) && (!isCollapsibleList || event.shiftKey)) {
            hideDropdownMenu();
          }
        }
      }
    }
    if (event.key === ARROW_DOWN_KEY && event.target.closest('#sib-dropdown-control-id') /*if not multiselect list*/ && !dropdownBodyRef.current?.children[0]?.classList?.contains(styles['sib-dropdown-multi-option'])) {
      dropdownBodyRef.current?.focus();
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleDocumentTabKey);
    if (isSearchable) {
      if (isMobile) {
        !isOverlayOpen && setSearchValue(null);
      } else {
        !isOpen && setSearchValue(null);
      }
    }
    return () => {
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('keydown', handleDocumentTabKey);
    };
  }, [isOpen, isOverlayOpen, disabled]);
  useEffect(() => {
    if (searchValue && searchValue.length > 0) {
      if (isMobile) {
        !isOverlayOpen && setIsOverlayOpen(true);
      } else {
        !isOpen && setIsOpen(true);
      }
    }
  }, [searchValue]);
  useLayoutEffect(() => {
    if (!isDropdownButton) {
      setDropdownWidth(dropdownRef?.current?.offsetWidth);
    }
  }, [dropdownRef?.current?.offsetWidth]);
  return /*#__PURE__*/React.createElement("div", {
    ref: dropdownRef,
    className: dropdownClass,
    disabled: disabled,
    id: "sib-dropdown-id",
    style: inlineDropdownStyles
  }, !!label && !isDropdownButton && /*#__PURE__*/React.createElement("label", {
    className: labelClass
  }, label, labelRequired ? /*#__PURE__*/React.createElement("span", {
    className: styles['sib-dropdown-label__required']
  }, "*") : null), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-dropdown-root'],
    style: inputStyles
  }, children), specificationText && !isDropdownButton && !isOpen ? /*#__PURE__*/React.createElement("p", {
    className: specificationTextClass
  }, specificationText) : null);
}
Dropdown.propTypes = {
  label: PropTypes.string.isRequired,
  isError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool.isRequired,
  inputStyles: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  labelRequired: PropTypes.bool.isRequired,
  isDropdownButton: PropTypes.bool.isRequired,
  specificationText: PropTypes.string.isRequired,
  inlineDropdownStyles: PropTypes.object.isRequired,
  isSearchable: PropTypes.bool.isRequired,
  isAbsoluteDropdown: PropTypes.bool,
  placement: PropTypes.string
};
export default Dropdown;